import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4cb8357b&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DefaultPageHeader: require('/tmp/build_4600e676/src/components/layout/DefaultPageHeader.vue').default,CardArticleSkeleton: require('/tmp/build_4600e676/src/components/card/ArticleSkeleton.vue').default,CardArticle: require('/tmp/build_4600e676/src/components/card/Article.vue').default,Observer: require('/tmp/build_4600e676/src/components/Observer.vue').default})
